import React from "react";
import { Col } from "react-bootstrap";
import SubmitButton from "@components/Buttons/SubmitButton/SubmitButton";

function SubmitAndRequestBtns({ onClick, style, label }) {
  return (
    <>
      <Col>
        <SubmitButton />
      </Col>
      <Col>
        <button type="button" className="btn btn-success" style={style} onClick={onClick}>
          <i className="fa fa-rss"></i> {label}
        </button>
      </Col>
    </>
  );
}

export default SubmitAndRequestBtns;
